// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1gSWF","listItem":"_2MaGG"};